export default (function () {
  let _onPageLoadCallbacks = [];
  let _isLoaded = document.readyState === 'complete';
  if (!_isLoaded) {
    window.addEventListener('load', function _onload() {
      _isLoaded = true;
      window.removeEventListener('load', _onload);
      _onPageLoadCallbacks.forEach(_cb => _cb())
      _onPageLoadCallbacks.length = 0;
    });
  }

  return callback => {
    if (_isLoaded) {
      callback();
    } else {
      _onPageLoadCallbacks.push(callback);
    }
  }
})();
